import React from 'react'
import './styles.css'

interface Operator {
    id: string,
    label: string,
    symbol: string
}

interface DropdownProps {
    values: Operator[],
    value: string,
    onSelect(e: string): any
}

export default function Dropdown(props: DropdownProps): JSX.Element {

    return (
        <select value={props.value} onChange={(e) => props.onSelect(e.target.value)}>
            {
                props.values.map((opt:Operator) => (
                    <option key={opt.id} id={opt.id} value={opt.id}>{opt.label}</option>
                ))
            }
        </select>
    )
}